import cn from 'clsx';
import React, { forwardRef } from 'react';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MenuItem from '@material-ui/core/MenuItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { NamedSettingsItemProps } from './table-named-settings-types';

export const useStyles = makeStyles(() => ({
  bullet: {
    width: 16,
    height: 16,
    borderRadius: 16,
    marginRight: 8,
    marginLeft: 14,
    flexShrink: 0,
    border: '1px solid grey',
    backgroundColor: 'white',
  },
  activeBullet: { backgroundColor: 'red' },
  disabledBullet: {
    backgroundColor: '#edecec',
    border: '1px solid #edecec',
    cursor: 'normal',
  },
  listItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
}));

export function NamedSettingsItemWithoutRef(
  {
    label,
    onClick,
    closeMenu,
    selected,
    isTop = false,
    onIsTopChange,
    showTopButton,
    disableTopButton,
  }: NamedSettingsItemProps,
  ref: React.Ref<any>
) {
  const classes = useStyles();
  return (
    <MenuItem ref={ref} onClick={() => {}}>
      {showTopButton && (
        <div
          className={cn(classes.bullet, {
            [classes.activeBullet]: isTop,
            [classes.disabledBullet]: disableTopButton,
          })}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (disableTopButton) return;
            onIsTopChange(!isTop);
          }}
        />
      )}
      <div
        style={{ fontWeight: selected ? 'bold' : 'normal' }}
        className={classes.listItem}
        onClick={() => {
          onClick();
          closeMenu();
        }}
      >
        <ListItemIcon>
          {selected && <ArrowRightIcon fontSize="default" />}
        </ListItemIcon>
        <>{label}</>
      </div>
    </MenuItem>
  );
}

export const NamedSettingsItem = forwardRef(NamedSettingsItemWithoutRef);
